"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const DraftEditor_1 = __importDefault(require("./DraftEditor"));
const MailIn_1 = __importDefault(require("./MailIn"));
const Overview_1 = __importDefault(require("./Overview"));
const Prizes_1 = __importDefault(require("./Prizes"));
const Settings_1 = __importDefault(require("./Settings"));
const Surveys_1 = __importDefault(require("./Surveys"));
const Winners_1 = __importDefault(require("./Winners"));
const graphql_1 = require("../../../requests/graphql");
const dispatchers_1 = require("../../../utility/dispatchers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const types_1 = require("./types");
const NESTED_FIELDS = new Set(['prizes', 'surveys']);
const CurrentView = (props) => {
    const { activeTab, errors, form, giveaway, overviewRef, pendingChanges, rulesRef, setErrors, setIsSubmitting, setForm, } = props;
    const [options, setOptions] = (0, react_1.useState)([]);
    const [inItOptions, setInItOptions] = (0, react_1.useState)([]);
    const [surveysSlugOptions, setSurveysSlugOptions] = (0, react_1.useState)([]);
    const handleUpdate = (0, react_1.useCallback)(({ name, value }) => {
        pendingChanges.add(name);
        if (NESTED_FIELDS.has(name)) {
            // Prizes can be an array of prizes that get updated. To keep them apart, we need to track them by id
            value.forEach((field) => {
                for (const [key] of Object.entries(field)) {
                    const fieldName = `${name}-${field?.id}-${key}`;
                    pendingChanges.add(fieldName);
                    const updatedErrors = errors;
                    delete updatedErrors[fieldName];
                    setErrors(updatedErrors);
                }
            });
        }
        else {
            // clear errors if change
            const updatedErrors = errors;
            delete updatedErrors[name];
            setErrors(updatedErrors);
        }
        setForm({ ...form, [name]: value });
    }, [errors, form, pendingChanges, setErrors, setForm]);
    // multiselect options for sponsors needs to be populated before the component is mounted.
    (0, react_1.useMemo)(() => {
        (0, graphql_1.graphMutate)({ t: 'get_channels_simple_pagination' }, { per_page: 500, sort: 'LAST_UPDATED' })
            .then(({ channels }) => {
            const opts = channels.records.map(({ name, id }) => ({
                label: name,
                value: id,
            }));
            setOptions(opts);
            const initialOptions = giveaway.sponsor_ids.flatMap((id) => opts.filter((option) => option.value === id));
            setInItOptions(initialOptions);
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway Dashboard get platforms: ', err);
            return;
        });
    }, [giveaway.sponsor_ids]);
    (0, react_1.useMemo)(() => {
        (0, graphql_1.graphMutate)({ t: 'get_survey_slugs' })
            .then(({ survey_slugs }) => {
            const opts = survey_slugs.map((slug) => ({
                label: slug,
                value: slug,
            }));
            setSurveysSlugOptions(opts);
        })
            .catch((err) => (0, error_handler_1.default)('fetch all survey slugs: ', err));
    }, []);
    switch (activeTab) {
        case 'description':
            return (react_1.default.createElement(DraftEditor_1.default, { key: `${activeTab}-description`, draftRef: overviewRef, field: "content", form: form, giveaway: giveaway, pendingChanges: pendingChanges, setIsSubmitting: setIsSubmitting }));
        case 'overview':
            return react_1.default.createElement(Overview_1.default, { handleUpdate: handleUpdate, ...props });
        case 'prizes':
            return react_1.default.createElement(Prizes_1.default, { handleUpdate: handleUpdate, ...props });
        case 'rules':
            return (react_1.default.createElement(DraftEditor_1.default, { key: `${activeTab}-rules`, draftRef: rulesRef, field: "rules", form: form, giveaway: giveaway, pendingChanges: pendingChanges, setIsSubmitting: setIsSubmitting }));
        case 'settings':
            return (react_1.default.createElement(Settings_1.default, { handleUpdate: handleUpdate, inItOptions: inItOptions, options: options, ...props }));
        case 'surveys':
            return (react_1.default.createElement(Surveys_1.default, { handleUpdate: handleUpdate, options: surveysSlugOptions, setErrors: setErrors, ...props }));
        case 'winners':
            return (react_1.default.createElement(Winners_1.default, { giveawayId: giveaway.id, pastWinners: giveaway.winners, prizes: giveaway.prizes }));
        case 'mailIn':
            return react_1.default.createElement(MailIn_1.default, { giveawayId: giveaway.id });
        default:
            (0, types_1.throwTypeError)(activeTab);
    }
};
exports.default = CurrentView;
